import { render, staticRenderFns } from "./BusinessNameFormFilesEscalated.vue?vue&type=template&id=4caefc79&scoped=true&"
import script from "./BusinessNameFormFilesEscalated.vue?vue&type=script&lang=js&"
export * from "./BusinessNameFormFilesEscalated.vue?vue&type=script&lang=js&"
import style0 from "./BusinessNameFormFilesEscalated.vue?vue&type=style&index=0&id=4caefc79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caefc79",
  null
  
)

export default component.exports